<template>
    <div>
        <!-- la modale de débug -->
        <b-modal id="debug-modal"
                 @ok="handleOk"
                 hide-header>
            <div class="d-block text-center alert alert-warning">
                <h3>Activer le mode debug</h3>
                Ce mode est réservé aux tests de l'application.
                <br/>Saisissez votre code:
                <form ref="form" @submit.stop.prevent="debugOn">
                    <b-form-group
                            label="Code"
                            :state="debugState"
                            label-for="debug-code-input"
                            invalid-feedback="Vous devez fournir un code valide."
                    >
                        <b-form-input
                                id="debug-code-input"
                                v-model="userDebugCode"
                                :state="debugState"
                                required
                        ></b-form-input>
                    </b-form-group>
                </form>

            </div>
        </b-modal>
        <!-- fin de la modale -->
        <!-- la modale de crédit -->
        <b-modal id="credit-modal"
                 @ok="$bvModal.hide('credit-modal')"
                 hide-header
                 ok-only
                 ok-title="Continuer">
            <div class="d-block text-center alert alert-info">
                <h3>Crédits</h3>
                <p>Cette application est proposée exclusivement dans le cadre du programme de gainage progressif de<br/> Laurent ROMEDENNE</p>
                <p>Cette application est conçue et développée par<br/> Michel VERDUN</p>
            </div>
        </b-modal>
        <!-- fin de la modale -->

        <div class="row">
            <div class="col-2">
                <b-icon v-if="!this.$store.getters.debug"
                        class="d-block d-sm-none pt-1"
                        font-scale="1.5"
                        icon="egg"
                        style="color: GrayText; cursor: pointer"
                        @click="$bvModal.show('debug-modal')"></b-icon>
                <b-icon v-if="!this.$store.getters.debug"
                        class="d-none d-sm-block pt-2"
                        font-scale="2"
                        icon="egg"
                        style="color: GrayText; cursor: pointer"
                        @click="$bvModal.show('debug-modal')"></b-icon>
            </div>
            <div class="col-8 text-center app-version"
                 style="color: royalblue; cursor: pointer"
                 @click="$bvModal.show('credit-modal')">v 0.9.0</div>
            <div class="col-2">
                    <span class="d-none d-sm-block ">
                       <b-icon icon="volume-up"
                               font-scale="3"
                               style="color: GrayText; cursor: pointer"
                               v-if="this.$store.getters.soundMode == true"
                               @click="soundOff"
                               v-b-tooltip.hover title="Le son est activé."
                       ></b-icon>
                        <b-icon icon="volume-mute"
                                font-scale="3"
                                style="color: GrayText; cursor: pointer"
                                v-if="this.$store.getters.soundMode == false"
                                @click="soundOn"
                                v-b-tooltip.hover title="Le son est coupé."
                        ></b-icon>
                    </span>
                <span class="d-block d-sm-none">
                       <b-icon icon="volume-up"
                               font-scale="2"
                               style="color: GrayText; cursor: pointer"
                               v-if="this.$store.getters.soundMode == true"
                               @click="soundOff"
                               v-b-tooltip.hover title="Le son est activé."
                       ></b-icon>
                        <b-icon icon="volume-mute"
                                font-scale="2"
                                style="color: GrayText; cursor: pointer"
                                v-if="this.$store.getters.soundMode == false"
                                @click="soundOn"
                                v-b-tooltip.hover title="Le son est coupé."
                        ></b-icon>
                    </span>
                <span>
                        <audio id="risingSound"
                               src="src/assets/sounds/uprising2.m4a"
                               type="audio/mp4">
                            Your browser does not support the
                            <code>audio</code> element.
                        </audio>
                    </span>
            </div>
        </div>
        <!-- debug panel -->
        <div v-if="this.$store.getters.debug" class="alert alert-warning">
            Mode debug activé:
            <router-link to="/home"><a>Home</a></router-link> |
            <router-link to="/disclaimer"><a>Disclaimer</a></router-link> |
            <router-link to="/training"><a>Training</a></router-link> |
            <router-link to="/program"><a>Program</a></router-link>
            <span v-if="isApple.isIOS">| Iphone ou Ipad détecté</span>
            <span v-if="isApple.isSafari">| Safari détecté</span>
            <span class="float-right">
                <b-icon icon="toggle-on"
                        flip-v
                        v-b-tooltip.hover title="Quitter le mode debug"
                        @click="$store.dispatch('updateDebug', false)"
                ></b-icon></span>
        </div>
    </div>
</template>
<script>
    export default {
        components: {

        },
        data: function () {
            return {
                debugState: null,
                userDebugCode: '',
            }
        },
        computed: {
            isApple: function() {
                let isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
                let isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
                return ({isSafari: isSafari, isIOS: isIOS});
            }

        },
        methods: {
            handleOk(bvModalEvt) {
                // Prevent modal from closing
                bvModalEvt.preventDefault()
                // Trigger submit handler
                this.debugOn();
            },

            debugOn: function () {
                this.debugState = ((this.$refs.form.checkValidity())
                    && (this.userDebugCode == this.$store.getters.debugCode));
                if (this.debugState) {
                    this.$store.dispatch('updateDebug', true);
                    this.$nextTick(() => {
                        this.$bvModal.hide('debug-modal')
                    });
                }


            },

            soundOff: function () {
                this.$store.dispatch('updateSound', false);
            },
            soundOn: function () {
                this.$store.dispatch('updateSound', true);
                //todo: Détection Apple IOS
                if(this.isApple.isSafari || this.isApple.isIOS) {
                    let x = document.getElementById("risingSound");
                    x.play();
                }

            }
        }
    }
</script>
<style>
    .app-version {
        font-size: smaller;
        color: lightgray;
        padding-top: 0.5em;
    }
</style>


// WEBPACK FOOTER //
// src/components/Header.vue